import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


@Component({
  selector: 'app-titan-information',
  templateUrl: './titan-information.component.html',
  styleUrls: ['./titan-information.component.scss']
})
export class TitanInformationComponent {

  titanImageURL: string = 'https://hips.hearstapps.com/hmg-prod/images/gettyimages-971463110.jpg';
  titanName: string = 'Julian Titán';
  titanLocation: string = 'Bogotá';
  pactsNumber: number = 24;
  titanID: number = 10071101587;
  titanSelections: number = 45;
  
  images = [
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/Mi-bebe-e-hijos-portada.webp',
      href: 'https://ejemplo.com/destino1'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/Mi-Ciudad-portada.webp',
      href: 'https://ejemplo.com/destino2'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/mi-compan204131i204129a-portada.webp',
      href: 'https://ejemplo.com/destino3'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/mi-educacio204129n-portada.webp',
      href: 'https://ejemplo.com/destino4'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/Mis-aficiones-y-pasatiempos-portada.webp',
      href: 'https://ejemplo.com/destino5'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/Mis-comidas-y-bebidas-portada.webp',
      href: 'https://ejemplo.com/destino6'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/Mis-inversiones-en-finca-raiz-portada.webp',
      href: 'https://ejemplo.com/destino7'
    },
    {
      src: 'https://dev.grantitan.com/wp-content/uploads/2023/04/Mi-trabajo-y-carrera-portada.webp',
      href: 'https://ejemplo.com/destino8'
    },
    {
      src: '',
      href: ''
    },
  ];
  currentIndex = 0;
  
  productos = [
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/03/1-pasteles.webp',
      titulo: 'Producto 1',
      descripcion: 'Descripción del producto 1 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi cuerpo y mi mente'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/3-Inteligencia-artificial-AI.webp',
      titulo: 'Producto 2',
      descripcion: 'Descripción del producto 2 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mis mascotas'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/03/3-bandera-de-japon.webp',
      titulo: 'Producto 3',
      descripcion: 'Descripción del producto 3 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi hogar y espacios'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/2-dinero-tarjeta-de-credito-y-candado.webp',
      titulo: 'Producto 4',
      descripcion: 'Descripción del producto 4 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi Dinero'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/2-dinero-tarjeta-de-credito-y-candado.webp',
      titulo: 'Producto 4',
      descripcion: 'Descripción del producto 4 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi Dinero'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/03/1-pasteles.webp',
      titulo: 'Producto 1',
      descripcion: 'Descripción del producto 1 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi cuerpo y mi mente'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/3-Inteligencia-artificial-AI.webp',
      titulo: 'Producto 2',
      descripcion: 'Descripción del producto 2 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mis mascotas'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/03/3-bandera-de-japon.webp',
      titulo: 'Producto 3',
      descripcion: 'Descripción del producto 3 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi hogar y espacios'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/2-dinero-tarjeta-de-credito-y-candado.webp',
      titulo: 'Producto 4',
      descripcion: 'Descripción del producto 4 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi Dinero'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/2-dinero-tarjeta-de-credito-y-candado.webp',
      titulo: 'Producto 4',
      descripcion: 'Descripción del producto 4 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Mi Dinero'
    },
    {
      imagen: 'https://dev.grantitan.com/wp-content/uploads/2023/04/2-dinero-tarjeta-de-credito-y-candado.webp',
      titulo: 'Producto 4',
      descripcion: 'Descripción del producto 4 Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis.',
      id: 'Jhoan de limon'
    },
  ];
  productosFiltrados: any[] = [];
  idsUnicos: string[] = [];
  filtroActual: string[] = [];
  visibleItems: number = 3.5;

  pageSize: number = 4; 
  currentPage: number = 0; 
  paginatedProductos: any[] = []; 
  totalPages: number = 0;

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit() {
    this.productosFiltrados = this.productos; 
    this.idsUnicos = Array.from(new Set(this.productos.map(producto => producto.id)));
    this.applyPagination();

    this.breakpointObserver.observe('(max-width: 1024px)').subscribe(result => {
      if (result.matches) {
          this.visibleItems = 1.8; 
      } else {
          this.visibleItems = 3.5;
      }
  });
  }

  showPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1;
    }
  }

  showNext() {
    if (this.currentIndex < this.images.length - 4) { 
      this.currentIndex += 1;
    }
  }

  changeSlide(index: number): void {
    this.currentIndex = index;
}

  filtrarProductos(id: string) {
  const index = this.filtroActual.indexOf(id);
  if (index > -1) {
    this.filtroActual.splice(index, 1);
  } else {
    this.filtroActual.push(id); 
  } 
  this.aplicarFiltros();
}

eliminarFiltros() {
  this.filtroActual = [];
  this.aplicarFiltros();
}

aplicarFiltros() {
  if (this.filtroActual.length > 0) {
    this.productosFiltrados = this.productos.filter(producto =>
      this.filtroActual.includes(producto.id)
    );
  } else {
    this.productosFiltrados = this.productos;
  }
}

nextPage() {
  const totalPages = Math.ceil(this.productosFiltrados.length / this.pageSize);
  if (this.currentPage < totalPages - 1) {
    this.currentPage++;
    this.applyPagination();
  }
}

previousPage() {
  if (this.currentPage > 0) {
    this.currentPage--;
    this.applyPagination();
  }
}

applyPagination() {
  const startIndex = this.currentPage * this.pageSize;
  const endIndex = startIndex + this.pageSize;
  this.paginatedProductos = this.productosFiltrados.slice(startIndex, endIndex);
  this.totalPages = Math.ceil(this.productosFiltrados.length / this.pageSize);
}

goToPage(page: number): void {
  this.currentPage = page;
  this.applyPagination();
}

  
}